/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ScreenerInsurance } from './ScreenerInsurance';
import {
    ScreenerInsuranceFromJSON,
    ScreenerInsuranceFromJSONTyped,
    ScreenerInsuranceToJSON,
} from './ScreenerInsurance';

/**
 * 
 * @export
 * @interface UpdateLeadInsurances200Response
 */
export interface UpdateLeadInsurances200Response {
    /**
     * 
     * @type {Array<ScreenerInsurance>}
     * @memberof UpdateLeadInsurances200Response
     */
    data?: Array<ScreenerInsurance>;
}

/**
 * Check if a given object implements the UpdateLeadInsurances200Response interface.
 */
export function instanceOfUpdateLeadInsurances200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateLeadInsurances200ResponseFromJSON(json: any): UpdateLeadInsurances200Response {
    return UpdateLeadInsurances200ResponseFromJSONTyped(json, false);
}

export function UpdateLeadInsurances200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeadInsurances200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(ScreenerInsuranceFromJSON)),
    };
}

export function UpdateLeadInsurances200ResponseToJSON(value?: UpdateLeadInsurances200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(ScreenerInsuranceToJSON)),
    };
}

